import { render, staticRenderFns } from "./TradingJfx.vue?vue&type=template&id=f247da9c&scoped=true&"
import script from "./TradingJfx.vue?vue&type=script&lang=js&"
export * from "./TradingJfx.vue?vue&type=script&lang=js&"
import style0 from "./TradingJfx.vue?vue&type=style&index=0&id=f247da9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247da9c",
  null
  
)

export default component.exports